import Cookies from 'js-cookie'
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { SETTINGS_PATH } from '@/app/router/paths'
import { AppMode } from '@/models/app'
import { appSlice } from '@/store/appSlice'
import { getColorShades } from '@/utils/getColorShades'
import { setDocumentVariables } from '@/utils/setDocumentVariables'
import { useAppSelector } from './store'
const KIOSK_PRIMARY_COLOR = '#046dd7'

export const useSetupKiosk = () => {
  const isKiosk = useAppSelector(appSlice.selectors.isKiosk)
  const navigate = useNavigate()
  const isSetup = useRef(false)

  useEffect(() => {
    if (!isKiosk || isSetup.current) return

    isSetup.current = true

    const elements = [document.body, document.documentElement]
    elements.forEach((element) => element.classList.add('kiosk'))

    const variables = getColorShades(KIOSK_PRIMARY_COLOR)

    if (!Cookies.get(import.meta.env.VITE_KIOSK_SETTINGS_COOKIE)) {
      navigate(`${SETTINGS_PATH}?ch=${AppMode.KIOSK}`)
    }

    return setDocumentVariables({
      callback: () => {
        elements.forEach((element) => element.classList.remove('kiosk'))
        isSetup.current = false
      },
      variables,
    })
  }, [isKiosk])
}
